import {html, LitElement, type TemplateResult} from "lit";
import {customElement, property} from "lit/decorators.js";
import Styles from "./legend.lit.scss";
import {pinIcon} from "./pinIcon";
import {COLOR_PRIMARY, COLOR_WHITE, getComputedColor, MARKER_COLOR_PROPS} from "./colors";

@customElement("eop-google-maps-legend-item")
export class EopGoogleMapsLegendItem extends LitElement {

    public static readonly styles = Styles;

    @property({attribute: "color"})
    public color: string;

    @property({attribute: "label"})
    public label: string;

    public render(): TemplateResult {
        return html`
            <div class="legend-item">
                <span class="icon">${this.markerIcon()}</span>
                <span class="label">${this.label}</span>
            </div>
        `;
    }

    private markerIcon(): Element {
        const strokeColor = getComputedColor(this, COLOR_WHITE);
        const fillColor = getComputedColor(this, MARKER_COLOR_PROPS[this.color] ?? COLOR_PRIMARY);
        return pinIcon({width: 25, height: 28, scale: 1.1}, fillColor, strokeColor);
    }
}